import { action } from 'typesafe-actions';

import { FetchUserPreferencesParams, UpdateUserPreferenceDTO } from 'clients/userPreference';
import { EntityId, EntityKind } from 'types/models/user-preference';

import ActionTypes from './constants';
import { MyPreference } from './types';

export const fetchMyPreferences = (entity?: FetchUserPreferencesParams) =>
  action(ActionTypes.FETCH_MY_PREFERENCES_REQUEST, { entity });

export const fetchMyPreferencesSuccess = () =>
  action(ActionTypes.FETCH_MY_PREFERENCES_SUCCESS);

export const fetchMyPreferencesFailure = (message: string) =>
  action(ActionTypes.FETCH_MY_PREFERENCES_FAILURE, { message }, undefined, true);

export const setMyPreferences = (preferences: MyPreference[]) =>
  action(ActionTypes.SET_MY_PREFERENCES, preferences);

export const editMyPreference = (updatedPreference: UpdateUserPreferenceDTO) =>
  action(ActionTypes.EDIT_MY_PREFERENCE_REQUEST, updatedPreference);

export const editMyPreferenceSuccess = () =>
  action(ActionTypes.EDIT_MY_PREFERENCE_SUCCESS);

export const editMyPreferenceFailure = (message: string) =>
  action(ActionTypes.EDIT_MY_PREFERENCE_FAILURE, { message }, undefined, true);

/** Used when the entity is deleted */
export const unsetMyPreference = (entityKind: EntityKind, entityId: EntityId) =>
  action(ActionTypes.UNSET_MY_PREFERENCE, { entityKind, entityId });
